<template>
  <div>
    <div v-if="settings&&settings.options.deliveryURL">
      <div v-if="iframeLoading" class="d-flex justify-center align-center" :style="{ height: wHeight + 'px' }">
        <v-progress-circular indeterminate size="80" width="6" color="black"></v-progress-circular>
      </div>
      <iframe
        :src="settings.options.deliveryURL"
        :style="{ width: '100%', height: iframeLoading ? '0' : wHeight + 'px', border: 'none', visibility: iframeLoading ? 'hidden' : 'visible' }"
        @load="iframeLoading = false"
      >
      </iframe>
    </div>
    <div v-else>
        <div class="d-flex align-center px-3 pt-3 pb-1">
          <v-icon color="black" class="mr-2">mdi-silverware</v-icon>
          <span class="text-h5 font-weight-bold black--text">{{ $t(page+'.Delivery') }}</span>
        </div>
        <v-container class="pt-0 px-0" :style="' height:'+ (contentHeight+153 )+ 'px; overflow-y: auto'">  
          <v-tabs 
            v-if="navigationStack.length === 0" 
            v-model="activeTab" 
            centered 
            background-color="white" 
            color="black"
            class="mb-0 pb-1 tabs-sticky"
          >
            <v-tab>{{$t(page+'.Food')}}</v-tab>
            <v-tab>{{$t(page+'.Drinks')}}</v-tab>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = true">
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </v-tabs>

          <!-- Breadcrumb Navigation (Chip Style) -->
          <div v-if="navigationStack.length > 0" class="mb-0 d-flex align-center flex-wrap breadcrumb-sticky">
            <!-- Home chip -->
            <v-chip
              small
              outlined
              color="black"
              class="breadcrumb-chip clickable"
              @click="goHome"
            >
              <v-icon small left>mdi-home</v-icon>
              Home
            </v-chip>
            
            <!-- Navigation chips -->
            <template v-for="(crumb, i) in navigationStack">
              <v-icon :key="`sep-${i}`" small class="mx-0 grey--text">mdi-chevron-right</v-icon>
              
              <!-- Clickable intermediate chips -->
              <v-chip
                v-if="i < navigationStack.length - 1"
                :key="`crumb-${i}`"
                small
                outlined
                color="black"
                class="breadcrumb-chip clickable"
                @click="goToLevel(i)"
              >
                {{ crumb.name }}
              </v-chip>
              
              <!-- Current level chip (solid) -->
              <v-chip
                v-else
                :key="`crumb-${i}`"
                small
                color="black"
                dark
                class="breadcrumb-chip"
              >
                <v-icon small left>mdi-map-marker</v-icon>
                {{ crumb.name }}
              </v-chip>
            </template>
          </div>

          <div 
            v-if="isCategoryView"
            :style="{ height: (contentHeight-40 )+ 'px', overflowY: 'auto' }"
            class="menu-scrollable-content"
          >
            <v-row>
              <v-col 
                v-for="item in currentDisplayItems" 
                :key="item.id" 
                cols="12" 
                sm="6" 
                md="4" 
              >
                <v-card 
                  class="rounded-lg fill-height hover-card" 
                  @click="drillDown(item)"
                  elevation="3"
                >
                  <v-img 
                    :src="item.image" 
                    height="200px"
                    class="align-end white--text"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.7)"
                  >
                    <template v-slot:default>
                        <div class="fill-height d-flex align-end img-gradient pa-4">
                            <span class="text-h5 font-weight-bold">{{ item.name }}</span>
                        </div>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </div>

          <div 
            v-else
            :style="{ height: (contentHeight-40 ) + 'px', overflowY: 'auto' }"
            class="menu-scrollable-content "
          >
            <v-row class="mx-2 mt-1">
              <v-col 
                v-for="product in currentProductList" 
                :key="product.id" 
                cols="12" 
                sm="6" 
                md="4"
                class="neu-glow2 rounded my-2"
              >
              <v-card class="rounded neu-glow2" elevation="2">
                <v-img 
                  v-if="product.image"
                  :src="product.image"
                  height="180px"
                  cover
                ></v-img>
                
                <div 
                  v-else 
                  color="grey lighten-3" 
                  height="100px" 
                  class="d-flex align-center justify-center rounded-t-lg"
                >
                  <v-icon size="64" color="grey">mdi-silverware-fork-knife</v-icon>
                </div>

                <v-card-title class="text-h6 font-weight-bold pb-0 product-title">
                  {{ product.name }}
                </v-card-title>

                <v-card-text class="flex-grow-1 pt-2">
                  <div class="text-body-2 grey--text text--darken-2 justify mb-2 product-description">
                    {{ product.description }}
                  </div>
                  
                  <div v-if="product.tags && product.tags.length > 0" class="d-flex flex-wrap mt-2">
                      <div v-for="tag in product.tags" :key="tag.id" class="mr-2" :title="tag.name">
                        <div v-html="tag.finalIcon || tag.icon_svg" style="width: 20px; height: 20px;"></div>
                      </div>
                  </div>
                </v-card-text>
                <v-card-actions class="white">                  
                  <div v-if="product.allergentags && product.allergentags.length > 0" class="d-flex align-center flex-wrap">
                    <v-tooltip 
                      v-for="(allergenId, i) in product.allergentags" 
                      :key="i" 
                      bottom
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-img
                          v-bind="attrs"
                          v-on="on"
                          :src="getAllergenIcon(allergenId)"
                          width="36"
                          height="36"
                          class="mr-1"
                          contain
                        />
                      </template>
                      <span>{{ getAllergenName(allergenId) }}</span>
                    </v-tooltip>
                  </div>
                  
                  <!--
                  <div v-if="product.allergentags && product.allergentags.length > 0" class="text-caption grey--text text--darken-1">
                    ({{ product.allergentags.join(', ') }})
                  </div>
                  -->
                  <v-spacer></v-spacer>
                  <div class="text-h6 font-weight-black green--text text--darken-2 mr-4">
                    {{ product.price }} {{ product.price_mode }}
                  </div>
                </v-card-actions>
              </v-card>
            </v-col>
            </v-row>
          </div>

        </v-container>


      <v-dialog v-model="dialog" width="600" scrollable>
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Informazioni & Allergeni
          </v-card-title>
          <v-card-text class="mt-4" style="max-height: 400px;">
            <div v-html="menuData.freetext"></div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click="dialog = false">
              Chiudi
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Booking",
  props: {
    customerId: {
      type: String,
      default: null
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      page: "Booking",
      stepper: 2,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      contentHeight: 0,
      loading: false,
      iframeLoading: true,
      activeTab: 0,
      dialog: false,
      navigationStack: [],
      menuData: {
        name: '',
        description: '',
        freetext: '',
        menucategories: [],
        menudrinkcategories: []
      },
      hasAuthenticated: false,
      snackbar: {
        active: false,
        color: 'success',
        text: ''
      },
      allergens: [
        {
            id: 1,
            name: "glutine",
			      icon:"gluten.png"
        },
        {
            id: 2,
            name: "crostacei",
			      icon:"shellfish.png"
        },
        {
            id: 3,
            name: "uova",
			      icon:"egg.png"
        },
        {
            id: 4,
            name: "pesce",
			      icon:"fish.png"
        },
        {
            id: 5,
            name: "arachidi",
			      icon:"peanuts.png"
        },
        {
            id: 6,
            name: "soia",
			      icon:"soy.png"
        },
        {
            id: 7,
            name: "latte",
			      icon:"milk.png"
        },
        {
            id: 8,
            name: "frutta a guscio",
			      icon:"nuts.png"
        },
        {
            id: 9,
            name: "sedano",
			      icon:"celery.png"
        },
        {
            id: 10,
            name: "senape",
			      icon:"mustard.png"
        },
        {
            id: 11,
            name: "sesamo",
			      icon:"sesame.png"
        },
        {
            id: 12,
            name: "anidride solforosa",
			      icon:"sulphites.png"
        },
        {
            id: 13,
            name: "lupini",
			      icon:"lupin.png"
        },
        {
            id: 14,
            name: "molluschi",
			      icon:"molluscs.png"
        }
    ]

    }
  },
  
  computed: {
    ...mapGetters(['settings', 'countries']),
    currentTitle() {
      if (this.navigationStack.length > 0) {
        return this.navigationStack[this.navigationStack.length - 1].name;
      }
      return this.menuData.name || 'Menu';
    },
    rootCategories() {
      if (this.activeTab === 0) {
        return this.menuData.menucategories.filter(c => c.parent_id === 0 || !c.parent_id);
      } else {
        if(!this.menuData.menudrinkcategories) return [];
        return this.menuData.menudrinkcategories.filter(c => c.parent_id === 0);
      }
    },
    isCategoryView() {
      if (this.navigationStack.length === 0) return true;
      const currentItem = this.navigationStack[this.navigationStack.length - 1];
      if (currentItem.children && currentItem.children.length > 0) return true;
      return false;
    },
    currentDisplayItems() {
      if (this.navigationStack.length === 0) return this.rootCategories;
      const currentItem = this.navigationStack[this.navigationStack.length - 1];
      return currentItem.children || [];
    },
    currentProductList() {
      if (this.navigationStack.length === 0) return [];
      const currentItem = this.navigationStack[this.navigationStack.length - 1];
      return currentItem.menuentries || [];
    }   
  },

  watch: {
    activeTab() {
      this.navigationStack = [];
    },    
    isActive: {
      immediate: true,  // Also check on initial mount
      handler(newVal) {
        // When tab becomes active and hasn't authenticated yet
        if (newVal && !this.hasAuthenticated) {
          this.getMenu()
        }
      }
    },   
  },

  mounted() {
    this.calculateContentHeight()
    window.addEventListener('resize', this.calculateContentHeight)
    window.addEventListener('orientationchange', this.calculateContentHeight)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.calculateContentHeight)
    window.removeEventListener('orientationchange', this.calculateContentHeight)
  },

  methods: {
    /**
     * Calculate available height for scrollable content
     */
    calculateContentHeight() {
      this.wHeight = window.innerHeight
      
      // Get app bar height
      const appBar = document.querySelector('.v-app-bar')
      const appBarHeight = appBar ? appBar.offsetHeight : 50
      
      // Get system bar height (dev mode)
      const systemBar = document.querySelector('.v-system-bar')
      const systemBarHeight = systemBar ? systemBar.offsetHeight : 0
      
      // Tabs/breadcrumb height (sticky elements)
      const tabsHeight = this.navigationStack.length === 0 ? 68 : 56
      
      // Container padding (top + bottom)
      const containerPadding = 24
      
      // Margin/spacing for content
      const contentMargin = 16
      
      // Calculate available height for scrollable area
      this.contentHeight = this.wHeight - appBarHeight - systemBarHeight - tabsHeight - containerPadding - contentMargin
      
      // Minimum height fallback
      if (this.contentHeight < 300) {
        this.contentHeight = 300
      }
    },

    /**
     * Navigate to specific breadcrumb level
     * @param {number} level - Index in navigation stack
     */
    goToLevel(level) {
      // Remove all items after the clicked level
      this.navigationStack = this.navigationStack.slice(0, level + 1)
      window.scrollTo(0, 0)
    },

    drillDown(item) {
      const hasChildren = item.children && item.children.length > 0;
      const hasProducts = item.menuentries && item.menuentries.length > 0;

      if (hasChildren || hasProducts) {
        this.navigationStack.push(item);
        window.scrollTo(0,0);
      }
    },
    
    goBack() {
      this.navigationStack.pop();
      window.scrollTo(0, 0);
    },
    
    goHome() {
      this.navigationStack = [];
      window.scrollTo(0, 0);
    },

    /**
     * Get allergen icon path by ID
     */
    getAllergenIcon(allergenId) {
      const allergen = this.allergens.find(a => a.id === allergenId)
      if (allergen && allergen.icon) {
        return `/static/users/pictures/allergens/${allergen.icon}`
      }
      return '/static/users/pictures/allergens/default.png'
    },

    /**
     * Get allergen name by ID
     */
    getAllergenName(allergenId) {
      const allergen = this.allergens.find(a => a.id === allergenId)
      return allergen ? allergen.name : 'Unknown'
    },

    /**
     * Load Menu data
     */
    async getMenu() {
      this.loading = true
      
      try {
        // Get hostname and locale
        const hostname = window.location.hostname
        
        // ✅ Axios interceptor automatically adds JWT and CSRF to headers
        // No need to manually add headers
        
        // Call API to get Menu
        const payload = JSON.stringify({
          action: 'getMenu',
          payload: {
            hostname: hostname,
            locale: this.settings.locale
          }
        })
        
        const res = await this.$http.post('/booking/booking_stepper.php', payload)
        
        if (res.data.errorid === '0') {
          // ✅ Axios response interceptor already updated JWT and CSRF tokens
          // No need to manually handle tokens
          
          // Update Vuex store with settings if returned
          if (res.data.payloads && res.data.payloads.settings) {
            sessionStorage.setItem('settings', JSON.stringify(res.data.payloads.settings))
            this.$store.dispatch('setSettings', res.data.payloads.settings)
          }
          
          // Load menu data
          this.menuData = res.data.payloads || []
          
          // Mark as authenticated
          this.hasAuthenticated = true
          this.loading = false
          
          // Recalculate height after menu loads
          this.$nextTick(() => {
            this.calculateContentHeight()
          })
        } else {
          this.showError('Failed to load Menu')
          this.loading = false
        }
      } catch (error) {
        console.error('Error loading Menu:', error)
        this.showError('Connection error')
        this.loading = false
      }
    },
    
    /**
     * Show error message in snackbar
     */
    showError(message) {
      this.snackbar = {
        active: true,
        color: 'error',
        text: message
      }
    },

    /**
     * Show success message in snackbar
     */
    showSuccess(message) {
      this.snackbar = {
        active: true,
        color: 'success',
        text: message
      }
    }
  }
}

</script>

<style>
.v-date-picker-table--date .v-btn.theme--dark {
  border-radius:3px!important;
  background-color: #292d32;
  /*
  -webkit-box-shadow: -3px -3px 4px #3e4247, 5px 5px 5px #1d1f23 !important;
  box-shadow: -3px -3px 4px #3e4247, 5px 5px 5px #1d1f23 !important;    
  */
}
.v-date-picker-table--date .v-btn.theme--light{
  border-radius:3px!important;
  background-color: #ededed;
  /*
  -webkit-box-shadow: -3px -3px 4px #3e4247, 5px 5px 5px #1d1f23 !important;
  box-shadow: -3px -3px 4px #3e4247, 5px 5px 5px #1d1f23 !important;    
  */
}
</style>
<style>
.v-stepper__step__step{
  display:none;
}
.v-stepper__label{
  display: block !important
}
.v-stepper__step{
  flex-basis: 75px !important;
}
.v-divider {
  max-width:20px!important;
  margin-top: 24px!important
}
.v-stepper__step{
  padding: 6px 24px
}
.v-stepper__label{
  height:46px;
}
.text-slotid-top{
  font-size:0.60rem !important;
}
.text-slotid-availability{
  font-size:0.65rem !important;
  padding: 3px 8px;
  margin-top: 6px;
  border-radius: 15px;
}
</style>
<style scoped>
.v-btn:before{
  background-color: unset!important;
}
.darkbg{
  background-color: #292d32!important;
}
.lightbg{
  background-color: #f2f3f7!important;
}
.transparent-bg{
  background:transparent!important;
}
.bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-size: cover;
    background-color: red;
    transform: scale(1.1);
  }

/* Scrollable content area */
.menu-scrollable-content {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
}

.menu-scrollable-content::-webkit-scrollbar {
  width: 8px;
}

.menu-scrollable-content::-webkit-scrollbar-track {
  background: transparent;
}

.menu-scrollable-content::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}

/* Sticky tabs and breadcrumbs */
.tabs-sticky {
  position: sticky;
  z-index: 10;
  background-color: var(--v-background-base, #fff);
  padding-bottom: 16px;
}

.theme--dark .tabs-sticky {
  background-color: var(--v-background-base, #121212);
}

.breadcrumb-sticky {
  position: sticky;
  z-index: 10;
  background-color: var(--v-background-base, #fff);
  padding: 16px 0;
}

.theme--dark .breadcrumb-sticky {
  background-color: var(--v-background-base, #121212);
}

/* Hover effect for category cards */
.hover-card {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  cursor: pointer;
}

.hover-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;
}

/* Gradient for category images */
.img-gradient {
  background: linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.7));
}

/* Chip-style breadcrumbs */
.breadcrumb-chip {
  margin: 2px 0;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
}

.breadcrumb-chip.clickable {
  cursor: pointer;
}

.breadcrumb-chip.clickable:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  background-color: rgba(33, 150, 243, 0.08) !important;
}

/* Mobile responsive breadcrumbs */
@media (max-width: 599px) {
  .breadcrumb-chip {
    font-size: 0.75rem;
    height: 24px !important;
  }
  
  .breadcrumb-chip .v-icon {
    font-size: 16px !important;
  }
}

/* Product title and description text wrapping */
.product-title {
  word-wrap: break-word;
  word-break: normal;
  overflow-wrap: break-word;
  hyphens: auto;
  line-height: 1.3;
}

.product-description {
  word-wrap: break-word;
  word-break: normal;
  overflow-wrap: break-word;
  hyphens: auto;
  line-height: 1.5;
}
</style>  